<template>
  <v-container fluid>
    <v-form v-model="valid">
      <v-card>
        <v-card-title primary-title>
          <span class="headline mb-0">Bulletin</span>
        </v-card-title>
        <v-card-actions>
          <v-btn :disabled="!valid" @click="save">{{$t('app.buttons.save')}}</v-btn>
          <v-btn @click="remove" v-if="$route.path.indexOf('new')===-1">{{$t('app.buttons.remove')}}</v-btn>
          <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
        </v-card-actions>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field label="Title" v-model="bulletin.title"/>
            </v-flex>
            <v-flex xs12>
              <v-textarea label="Content" v-model="bulletin.content"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      bulletin: {
        title: null,
        content: null
      }
    }
  },
  methods: {
    save() {
      this.$http.post('/bulletins', this.bulletin).then(() => {
        this.$router.go(-1)
      })
    },
    remove() {}
  }
}
</script>
